export default {
    aws_account: 'គណនី AWS',
    aws_invoice: 'វិក្កយបត្រ AWS',
    aws_contracts: 'កិច្ចសន្យា AWS',
    status: 'ស្ថានភាព',
    aws_account_id: 'លេខសម្គាល់គណនី AWS',
    aws_account_name: 'ឈ្មោះគណនី AWS',
    discount_rate: 'អត្រាបញ្ចុះតម្លៃ',
    reg_date: 'កាលបរិច្ឆេទចុះបញ្ជី',
    placeholder_search: 'លេខសម្គាល់គណនី AWS, ឈ្មោះគណនី AWS',
    discount_from: 'ការបញ្ចុះតម្លៃពី',
    cost_explorer: 'អ្នករុករកការចំណាយ',
    others: 'ផ្សេងៗ',
    total_costs: 'ការចំណាយសរុប',
    total_cost: 'ការចំណាយសរុប',
    average_daily_cost: 'ការចំណាយប្រចាំថ្ងៃជាមធ្យម',
    average_cost: 'តម្លៃជាមធ្យម {granularity}',
    dimension_count: 'ចំនួន {dimensionGroupName}',
    cost_breakdown: 'ការវិភាគថ្លៃដើម និងការប្រើប្រាស់',
    total: 'សរុប',
    clear_filter: 'ជម្រះតម្រង',
    date_range: 'ជួរកាលបរិច្ឆេទ',
    granularity: 'ភាពលម្អិត',
    group_by: 'ក្រុម ដោយ',
    filter: {
        today: 'ថ្ងៃនេះ',
        last_7_days: '7 ថ្ងៃ',
        this_month: 'ខែ​នេះ',
        last_month: 'ខែមុន',
        last_2_months: '2 ខែចុងក្រោយ',
    },
    group: {
        service: 'Service',
        linked_account: 'Linked account',
        region: 'Region',
        instance_type: 'Instance type',
        usage_type: 'Usage type',
        charge_type: 'Charge type',
    },
    date_type: {
        daily: 'ប្រចាំថ្ងៃ',
        monthly: 'ប្រចាំខែ',
    },
    chart_types: {
        stack: 'Stack',
        bar: 'Bar',
    },
    invoices_unpaid: 'មានវិក្កយបត្រមួយចំនួនដែលត្រូវបង់ប្រាក់',
    only_show_unpaid: 'បង្ហាញតែវិក្កយបត្រមិនទាន់បង់ប្រាក់ប៉ុណ្ណោះ។',
    costs: 'ការចំណាយ ({currencyCode})',
    billing_detail: 'ព័ត៌មានលម្អិតអំពីការចេញវិក្កយបត្រ',
    aws_billing_detail: 'ព័ត៌មានលម្អិតអំពីវិក័យប័ត្រ AWS',
    estimated_bill_summary: {
        title: 'ការប៉ាន់ស្មានសេចក្តីសង្ខេបវិក័យប័ត្រ',
        bill_summary: 'សង្ខេបវិក័យប័ត្រ',
        estimated_grand_total: 'ការប៉ាន់ស្មានតម្លៃសរុប',
        grand_total: 'តម្លៃសរុប',
        aws_inc: 'សេវាកម្ម Amazon Web, Inc',
        aws_marketplace: 'សេវាកម្ម Amazon Web, Inc​ - តម្លៃទីផ្សារ',
        billing_info: 'ព័ត៌មានវិក័យប័ត្រ',
        account_id: 'លេខសម្គាល់គណនី',
        billing_period: 'រយៈពេលចេញវិក្កយបត្រ',
        invoice_status: 'ស្ថានភាពវិក្កយបត្រ',
    },
    usage_quantity: 'បរិមាណប្រើប្រាស់',
    charges_by_service: 'សេវាកម្ម Amazon Web, Inc . គិតថ្លៃសេវា',
    marketplace_charges_by_service:
        'សេវាកម្ម Amazon Web, Inc​ - គិតថ្លៃសេវាតាមតម្លៃទីផ្សារ ',
    total_active_services: 'សេវាកម្មសកម្មសរុប',
    total_charge: 'ការគិតថ្លៃសរុប',
    bill_issued: 'ចេញវិក័យប័ត្រ',
    date_printed: 'កាលបរិច្ឆេទបោះពុម្ព',
    aws_bill_summary: 'សង្ខេបវិក័យប័ត្រ AWS',
    service_provider: 'អ្នកផ្តល់សេវា',
};
